// PHA-1168: "View: Phanova Standard / <saved views>" picker for the Patient List
// and the Billing Report.
import React from 'react';
import { Flex, Select, Text } from '@radix-ui/themes';
import type { CustomViewSummary } from '../../services/api';
import { STANDARD, ViewChoice } from './useCustomViews';

const MANAGE = '__manage__';

interface ViewSelectorProps {
  views: CustomViewSummary[];
  activeViewId: number | null;
  onChange: (choice: ViewChoice) => void;
  /** Shown to clinic admins: jumps to Clinic Settings > Views. */
  onManage?: () => void;
}

const ViewSelector: React.FC<ViewSelectorProps> = ({ views, activeViewId, onChange, onManage }) => {
  const value = activeViewId === null ? STANDARD : String(activeViewId);
  return (
    <Flex align="center" gap="2">
      <Text size="2" color="gray" as="label" htmlFor="custom-view-select">View</Text>
      <Select.Root
        size="2"
        value={value}
        onValueChange={(v) => {
          if (v === MANAGE) { onManage?.(); return; }
          onChange(v === STANDARD ? STANDARD : Number(v));
        }}
      >
        <Select.Trigger id="custom-view-select" aria-label="Select view" data-testid="custom-view-select" />
        {/* popper, not item-aligned: see project note on the Radix empty dropdown. */}
        <Select.Content position="popper">
          <Select.Item value={STANDARD}>Phanova Standard</Select.Item>
          {views.length > 0 && <Select.Separator />}
          {views.map((v) => (
            <Select.Item key={v.id} value={String(v.id)}>
              {v.name}
              {v.effective_default ? ' (default)' : ''}
            </Select.Item>
          ))}
          {onManage && (
            <>
              <Select.Separator />
              <Select.Item value={MANAGE}>Manage views…</Select.Item>
            </>
          )}
        </Select.Content>
      </Select.Root>
    </Flex>
  );
};

export default ViewSelector;
